module.exports = __webpack_public_path__ + "img/filter-img.524db888.png";